export const SSO_AUTH_TYPES = {
  saml: 'saml',
  oidc_pkce: 'oidc_pkce',
  oidc_implicit: 'oidc_implicit',
  none: 'none',
  google: 'google',
};

export const SSO_AUTH_KEYS = {
  authMode: 'sso_type',
  oidc_auth_url: 'oidc.auth_url',
  oidc_client_id: 'oidc.auth_url_param.client_id',
  oidc_token_url: 'oidc.token_url',
  oidc_audience_id: 'oidc.auth_url_param.audience',
  nexla_token_url: 'nexla.sso_token_url',
  saml_acs_url: 'saml.acs_url',
  saml_sso_id: 'saml.sso_id',
  saml_sso_url: 'saml.sso_url',
  nexla_token_url_redirect: 'nexla.token_url_redirect',
  idp: 'idp',
};

export const OIDC_SSO_TYPES = [SSO_AUTH_TYPES.oidc_implicit, SSO_AUTH_TYPES.oidc_pkce];

export const SUPPORTED_OIDC_SSO_TYPES = [SSO_AUTH_TYPES.oidc_implicit, SSO_AUTH_TYPES.oidc_pkce];

export const DATATYPE_MACRO_SETTINGS = {
  MACRO_PREFIX: 'datatype.',
  MACRO_KEYS: {
    nonce: 'nonce',
    oidc_code_verifier: 'oidc_code_verifier',
    oidc_code_challenge: 'oidc_code_challenge',
  },
};
